module.exports = __webpack_public_path__ + "static/product3-a-af398d6f1658d8c138a5211372042dfb.pdf";